// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 00601-单个文件上传 POST /base/v1/file/uploadSingleFile */
export async function uploadSingleFile(
  body: {},
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>("/base/v1/file/uploadSingleFile", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
